<template>
  <div class="my-main-content-web">
    <div style="margin-top:5vh; margin-right: 8vw; margin-left: 8vw;">
      <h3 class="text3D">
        <span @click="$routerTo('/Admin')" style="border-bottom: 1px solid;cursor: pointer;">後台設定</span>
        <span> / </span>
        <span>文獻管理 </span>
      </h3>

      <el-row>
        <el-col :span="4">
          <el-button size="small" type="success" @click="$routerTo('AdminDocumentSet/0')">新增</el-button>
        </el-col>

        <el-col :span="18">
          <el-input @keypress.enter.native="searchKey()" placeholder="請輸入內容" v-model="input_search" class="input-with-select" size="small">
            <el-button @click="searchKey()" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center" style="margin-top:10px">
        <el-col :span="8">
          <el-radio-group v-model="selected_floor" @change="changeFloor" size="small">
            <el-radio-button style="color:white" :label="1">1樓</el-radio-button>
            <el-radio-button style="color:white" :label="2">2樓</el-radio-button>
            <el-radio-button style="color:white" :label="3">3樓</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <div style="margin-top: 10px; text-align: left">
        <el-radio-group v-model="selected_area" @change="changeArea">
          <el-radio style="color: white; padding: 3px; width: 70px" v-for="(area, index) in areas_options" :key="index" :label="area">{{ area["area_zh-TW"] }}</el-radio>
        </el-radio-group>
      </div>

      <div class="list-section" style="padding-top: 5px; padding-bottom: 8px;">
        <h1>
          <span v-if="area_ID">{{ floor }}樓 -- {{ area }}</span>
          <span v-if="search">{{ search }}</span>
          <span v-if="!area_ID && !search">請選擇區域</span>
        </h1>
      </div>

      <template v-if="area_ID || search">
        <el-row>
          <el-pagination @current-change="changePage" background layout="prev, pager, next" :total="paging.total" :current-page.sync="paging.page"></el-pagination>
        </el-row>

        <el-row v-if="documents.length > 0">
          <!-- 文獻列表 -->
          <el-col :lg="6" :md="8" :sm="12" :xs="24" v-for="(document, index) in documents" :key="index">
            <el-card :body-style="{ padding: '10px' }" style="background-color: blanchedalmond; margin:10px">
              <el-row>
                <el-col :span="8">
                  <div @click="$routerTo('AdminDocumentSet/' + document.recno)" class="square-img" style="text-align:left">
                    <img v-if="document.id.indexOf('/image/') > -1" :src="document.id" class="image" />
                    <img v-else :src="'/image/' + document.id + '_thumbnail.jpg'" class="image" />
                  </div>
                </el-col>

                <el-col :span="16">
                  <div style="padding: 10px;height: 50px; text-align: left;">
                    <span class="two-line-text">{{ document.name }}</span>
                    <span class="two-line-text">{{ document.donor }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <h3 v-else>此區域沒有文獻</h3>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      paging: {
        page: 1,
        total: 30
      },
      input_search: "",
      search: "",
      area: "",
      floor: "",
      selected_area: "",
      selected_floor: "",
      areas: [],
      areas_options: [],
      documents: [],
      document: {
        img: "",
        room: "",
        location: "",
        area: "",
        donor: "",
        donor_date: "",
        year: "",
        recno: "",
        name: "",
        width: "",
        length: "",
        doc: "",
        id: "",
        floor: "",
        height: "",
        weight: ""
      }
    };
  },
  computed: {
    ...mapState(["area_ID"])
  },
  mounted() {
    this.$store.commit("set_page", location.hash);

    this.areas = JSON.parse(localStorage.getItem("areas"));
    this.areas.forEach(el => {
      if (el.recno == this.area_ID) {
        this.selected_floor = el.floor;
        this.floor = el.floor;
        this.area = el["area_zh-TW"];
        this.selected_area = el;
      }
    });
    this.initAreas();
    console.log(this.area_ID);
    if (this.area_ID) {
      this.searchDocument();
    }
  },
  methods: {
    changeFloor() {
      this.search = "";
      this.paging.page = 1;
      this.$store.commit("setArea_ID", "");

      this.initAreas();
    },
    changeArea(area) {
      console.log(area);
      this.paging.page = 1;
      this.areas.forEach(el => {
        if (el.recno == area.recno) {
          this.floor = el.floor;
          this.area = el["area_zh-TW"];
          this.selected_area = el;
        }
      });

      this.$store.commit("setArea_ID", area.recno);

      this.searchDocument();
    },
    async searchDocument() {
      this.$store.commit("setLoadingMask", true);

      let params = {};

      if (this.area_ID) {
        params.area = this.area_ID;
      }
      if (this.search) {
        params.search = this.search;
      }
      params.page = this.paging.page;

      await axios
        .get("api/document", { params })
        .then(response => {
          this.documents = response.data.data;
          this.paging.total = response.data.total;
          console.log(this.paging.total);
          response.data.data.forEach(element => {
            for (let key in this.document) {
              if (element[key] == undefined) {
                element[key] = "";
              }
            }
          });
        })
        .catch(error => {
          console.log(error.message);
        });

      this.$store.commit("setLoadingMask", false);
    },
    changePage(val) {
      this.paging.page = val;
      this.searchDocument();
    },
    initAreas() {
      let areas = JSON.parse(localStorage.getItem("areas"));

      if (this.selected_floor == "1") {
        this.areas_options = this.areas.filter(el => {
          return el.floor == 1;
        });
      } else if (this.selected_floor == "2") {
        this.areas_options = this.areas.filter(el => {
          return el.floor == 2;
        });
      } else if (this.selected_floor == "3") {
        this.areas_options = this.areas.filter(el => {
          return el.floor == 3;
        });
      }
    },
    searchKey() {
      this.areas_options = [];
      this.search = this.input_search;
      this.selected_area = "";
      this.selected_floor = "";
      this.paging.page = 1;
      this.$store.commit("setArea_ID", "");

      this.searchDocument();
    }
  }
};
</script>
